import React from 'react'
import CompanyPrimaryUser from 'graphs/queries/CompanyPrimaryUser.graphql'
import fields from 'fields/users'
import { withRouter } from 'react-router-dom'
import companyRemovePrimaryUser from 'graphs/mutations/companyRemovePrimaryUser.graphql'
import BelongsTo from 'components/BelongsTo'

const RouteCompanyPrimaryUser = ({ company, history, ...props }) => (
  <BelongsTo
    query={CompanyPrimaryUser}
    variables={{ company_id: company.id }}
    namespace="company.primary_user"
    removeMutation={companyRemovePrimaryUser}
    removeMutationArgs={{ variables: { id: company.id } }}
    fields={fields}
    onRowClick={(e, row) => history.push(`/admin/users/${row.id}`)}
    {...props}
  />
)

export default withRouter(RouteCompanyPrimaryUser)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/primary_user/index.js